import { getFeatureFlag } from "@sinch/feature-flags";
import { config, type FinalShellEnv } from "./client";

declare global {
  interface Window {
    SHELL_ENV: FinalShellEnv;
    SHELL_BOOTSTRAP: {
      ff: { [key: string]: string | boolean | number };
    };
  }
}

console.log("config loaded with env:", window.SHELL_ENV);

export const getMessageMediaApiUrlMiddleware = () =>
  getFeatureFlag(
    "messageMediaApiUrlMiddleware",
    // Not using ff helper here since it's top level and get evaluated even on portals that use this mfe.
    // And the ff helper console errors it.
    (x): x is string => typeof x === "string",
    config.API_BASE_URL
  );
export const getMessageMediaApiUrl = () =>
  getFeatureFlag(
    "messageMediaApiUrl",
    // Not using ff helper here since it's top level and get evaluated even on portals that use this mfe.
    // And the ff helper console errors it.
    (x): x is string => typeof x === "string",
    config.SHELL_ENV.NEXTGEN_API_URL
  );
export const getOnesaasApiUrlAuth = () =>
  getFeatureFlag(
    "onesaasApiUrlAuth",
    // Not using ff helper here since it's top level and get evaluated even on portals that use this mfe.
    // And the ff helper console errors it.
    (x): x is string => typeof x === "string",
    config.AUTH_CONFIG.url
  );

export const getZendeskScriptUrl = () =>
  "https://static.zdassets.com/ekr/snippet.js?key=";
